(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection-list]').forEach(function (root) {
      const track = root.querySelector('[data-cl-track]');
      if (!track) return;
      const prev = root.querySelector('[data-cl-prev]');
      const next = root.querySelector('[data-cl-next]');

      function step(dir) {
        const card = track.querySelector('.collection-card');
        const amount = card ? card.offsetWidth + 16 : track.clientWidth * 0.6;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const events = document.querySelectorAll('[data-event]');
    if (!events.length) return;

    if (!('IntersectionObserver' in window)) {
      events.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

    events.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exclusive-deals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-exdeals]').forEach(function (root) {
      const track = root.querySelector('[data-ex-track]');
      if (!track) return;
      function step(dir) {
        const item = track.querySelector('.exdeals__item, .exdeals__promo');
        const amount = item ? item.offsetWidth + 16 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      const prev = root.querySelector('[data-ex-prev]');
      const next = root.querySelector('[data-ex-next]');
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-deal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-deal]').forEach(function (root) {
      const dots = root.querySelectorAll('[data-deal-dot]');
      const panels = root.querySelectorAll('[data-deal-panel]');

      function activate(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.index === String(i)); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.index === String(i)); });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { activate(dot.dataset.index); });
        dot.addEventListener('mouseenter', function () { activate(dot.dataset.index); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fproduct__qty').forEach(function (qty) {
      const input = qty.querySelector('.fproduct__qty-input');
      const minus = qty.querySelector('[data-qty-minus]');
      const plus = qty.querySelector('[data-qty-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      plus && plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    document.querySelectorAll('[data-fp-gallery]').forEach(function (gallery) {
      const main = gallery.querySelector('[data-fp-main]');
      const thumbs = gallery.querySelectorAll('[data-fp-thumb]');
      if (!main) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          const full = thumb.getAttribute('data-full');
          if (full) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    /* Expose the header height so sticky elements (e.g. collection toolbar) can sit under it */
    const setHeaderH = function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setHeaderH();
    window.addEventListener('resize', setHeaderH, { passive: true });

    /* Mobile drill-down menu */
    const toggle = header.querySelector('[data-menu-toggle]');
    const mnav = document.querySelector('[data-mnav]');
    if (toggle && mnav) {
      const resetPanels = function () {
        mnav.querySelectorAll('.mnav__panel.is-active').forEach(function (p) {
          if (!p.classList.contains('mnav__panel--root')) p.classList.remove('is-active');
        });
      };
      const setMenu = function (open) {
        mnav.classList.toggle('is-open', open);
        mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
        if (!open) setTimeout(resetPanels, 280);
      };
      toggle.addEventListener('click', function () { setMenu(!mnav.classList.contains('is-open')); });
      mnav.querySelectorAll('[data-mnav-close]').forEach(function (el) {
        el.addEventListener('click', function () { setMenu(false); });
      });
      mnav.querySelectorAll('[data-mnav-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const panel = mnav.querySelector('.mnav__panel[data-mnav-panel="' + btn.getAttribute('data-mnav-open') + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
      mnav.querySelectorAll('[data-mnav-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const panel = btn.closest('.mnav__panel');
          if (panel) panel.classList.remove('is-active');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mnav.classList.contains('is-open')) setMenu(false);
      });
    }

    /* Contained at top, full-width on scroll — on every page */
    {
      let ticking = false;
      const onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          header.classList.toggle('is-stuck', window.scrollY > 60);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Search panel */
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchPanel = header.querySelector('[data-search-panel]');
    const searchClose = header.querySelector('[data-search-close]');
    const searchInput = header.querySelector('[data-search-input]');
    if (searchToggle && searchPanel) {
      const openSearch = function () {
        searchPanel.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        if (searchInput) searchInput.focus();
      };
      const closeSearch = function () {
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      };
      searchToggle.addEventListener('click', openSearch);
      searchClose && searchClose.addEventListener('click', closeSearch);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-hero-track]');
      var prev = slider.querySelector('[data-hero-prev]');
      var next = slider.querySelector('[data-hero-next]');
      if (!track) return;

      function step() {
        var s = track.querySelector('.hero__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return s ? s.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-its]').forEach(function (root) {
      const slides = Array.prototype.slice.call(root.querySelectorAll('[data-its-slide]'));
      const current = root.querySelector('[data-its-current]');
      const total = slides.length;
      if (total < 2) return;

      let index = 0;
      let animating = false;

      function go(next) {
        next = (next + total) % total;
        if (next === index || animating) return;
        animating = true;

        const cur = slides[index];
        const nxt = slides[next];

        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        nxt.classList.add('is-active');

        if (current) current.textContent = String(next + 1);
        index = next;

        setTimeout(function () {
          cur.classList.remove('is-leaving');
          animating = false;
        }, 1000);
      }

      const prev = root.querySelector('[data-its-prev]');
      const next = root.querySelector('[data-its-next]');
      prev && prev.addEventListener('click', function () { go(index - 1); });
      next && next.addEventListener('click', function () { go(index + 1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-filter-drawer]');
    var openBtn = document.querySelector('[data-filter-open]');
    if (drawer && openBtn) {
      var setDrawer = function (open) {
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.style.overflow = open ? 'hidden' : '';
      };
      openBtn.addEventListener('click', function () { setDrawer(true); });
      drawer.querySelectorAll('[data-filter-close]').forEach(function (el) {
        el.addEventListener('click', function () { setDrawer(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false);
      });
    }

    // Toolbar: contained at top, full-width once it sticks under the header
    var sentinel = document.querySelector('[data-toolbar-sentinel]');
    var bar = document.querySelector('[data-collection-bar]');
    if (sentinel && bar && 'IntersectionObserver' in window) {
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 88;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { rootMargin: '-' + (headerH + 1) + 'px 0px 0px 0px', threshold: 0 }).observe(sentinel);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp]').forEach(function (root) {
      // gallery swap + hover zoom
      var gallery = root.querySelector('[data-pdp-gallery]');
      if (gallery) {
        var main = gallery.querySelector('[data-pdp-main]');
        var mainWrap = gallery.querySelector('.pdp__main');
        var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
        var zoom = null;

        thumbs.forEach(function (thumb) {
          var f = thumb.getAttribute('data-full');
          if (f) { var im = new Image(); im.src = f; }
        });

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var full = thumb.getAttribute('data-full');
            if (full && main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            if (zoom) zoom.style.backgroundImage = 'url(' + full + ')';
          });
        });

        // prev/next over the main image cycle through the gallery
        var prevBtn = gallery.querySelector('[data-pdp-prev]');
        var nextBtn = gallery.querySelector('[data-pdp-next]');
        if ((prevBtn || nextBtn) && thumbs.length) {
          var go = function (dir) {
            var arr = [].slice.call(thumbs);
            var active = gallery.querySelector('[data-pdp-thumb].is-active');
            var i = arr.indexOf(active);
            if (i < 0) i = 0;
            i = (i + dir + arr.length) % arr.length;
            arr[i].click();
          };
          if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
        }

        if (mainWrap && main) {
          zoom = document.createElement('div');
          zoom.className = 'pdp__zoom';
          // append to <body> + fixed positioning so no column stacking context can
          // ever paint over it (product title was showing through otherwise)
          document.body.appendChild(zoom);
          var lens = document.createElement('div');
          lens.className = 'pdp__lens';
          mainWrap.appendChild(lens);
          var place = function (r) {
            zoom.style.top = Math.max(8, r.top) + 'px';
            zoom.style.left = (r.right + 20) + 'px';
          };
          mainWrap.addEventListener('mouseenter', function () {
            if (window.innerWidth < 1100) return;
            zoom.style.backgroundImage = 'url(' + (main.currentSrc || main.src) + ')';
            place(mainWrap.getBoundingClientRect());
            zoom.classList.add('is-visible');
            mainWrap.classList.add('is-zooming');
          });
          mainWrap.addEventListener('mouseleave', function () {
            zoom.classList.remove('is-visible');
            mainWrap.classList.remove('is-zooming');
          });
          mainWrap.addEventListener('mousemove', function (e) {
            var r = mainWrap.getBoundingClientRect();
            place(r);
            var px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
            var py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
            zoom.style.backgroundPosition = (px * 100) + '% ' + (py * 100) + '%';
            lens.style.left = (px * 100) + '%';
            lens.style.top = (py * 100) + '%';
          });
        }
      }

      // Hemen Al -> add then go to checkout
      var buyNow = root.querySelector('[data-pdp-buynow]');
      var form = root.querySelector('.pdp__form');
      if (buyNow && form) {
        buyNow.addEventListener('click', function () {
          buyNow.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
            .catch(function () { buyNow.disabled = false; form.submit(); });
        });
      }

      // Product details tabs
      var tabWrap = root.querySelector('[data-pdp-tabs]');
      if (tabWrap) {
        var tabs = tabWrap.querySelectorAll('[data-tab]');
        var panels = root.querySelectorAll('.pdp-details__panel');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-tab');
            tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
            panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
          });
        });
      }

      // sticky add-to-cart bar — show once the whole product area scrolls past
      // (watch the layout, not the add button, since the buy card is sticky)
      var sticky = document.querySelector('[data-pdp-sticky]');
      var mainAdd = root.querySelector('.pdp__add');
      var watch = root.querySelector('.pdp__layout');
      if (sticky && mainAdd && watch && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(watch);
        var sAdd = sticky.querySelector('[data-pdp-sticky-add]');
        if (sAdd) sAdd.addEventListener('click', function () { mainAdd.click(); });
      }

      // variant swatch selected state
      root.querySelectorAll('.pdp__swatch input').forEach(function (input) {
        input.addEventListener('change', function () {
          var name = input.name;
          root.querySelectorAll('.pdp__swatch input[name="' + CSS.escape(name) + '"]').forEach(function (i) {
            i.closest('.pdp__swatch').classList.toggle('is-selected', i.checked);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-promo]').forEach(function (root) {
      const track = root.querySelector('[data-promo-track]');
      if (!track) return;
      function step(dir) {
        const card = track.querySelector('.promo-card');
        const amount = card ? card.offsetWidth + 16 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      const prev = root.querySelector('[data-promo-prev]');
      const next = root.querySelector('[data-promo-next]');
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-recently-viewed]').forEach(function (root) {
      var track = root.querySelector('[data-rv-track]');
      var prev = root.querySelector('[data-rv-prev]');
      var next = root.querySelector('[data-rv-next]');
      if (!track) return;
      function step(dir) {
        var item = track.firstElementChild;
        var amount = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tabbed]').forEach(function (root) {
      const tabs = root.querySelectorAll('[data-tab]');
      const panels = root.querySelectorAll('[data-panel]');
      const indicator = root.querySelector('[data-tp-indicator]');

      function moveIndicator(tab) {
        if (!indicator || !tab) return;
        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.height = tab.offsetHeight + 'px';
        indicator.style.transform = 'translate(' + tab.offsetLeft + 'px, ' + tab.offsetTop + 'px)';
      }

      function activate(i) {
        tabs.forEach(function (t) {
          const on = t.dataset.tab === String(i);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) moveIndicator(t);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === String(i));
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.dataset.tab); });
      });

      function syncIndicator() {
        moveIndicator(root.querySelector('[data-tab].is-active') || tabs[0]);
      }
      requestAnimationFrame(syncIndicator);
      window.addEventListener('load', syncIndicator);
      window.addEventListener('resize', syncIndicator);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncIndicator); }

      function activeTrack() {
        const panel = root.querySelector('[data-panel].is-active');
        return panel ? panel.querySelector('[data-tp-track]') : null;
      }

      function step(dir) {
        const track = activeTrack();
        if (!track) return;
        const item = track.querySelector('.tabbed-products__item');
        const amount = item ? item.offsetWidth + 16 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      const prev = root.querySelector('[data-tp-prev]');
      const next = root.querySelector('[data-tp-next]');
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-testimonials]').forEach(function (root) {
      const track = root.querySelector('[data-tm-track]');
      if (!track) return;
      function step(dir) {
        const card = track.querySelector('.tcard');
        const amount = card ? card.offsetWidth + 16 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      const prev = root.querySelector('[data-tm-prev]');
      const next = root.querySelector('[data-tm-next]');
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
